import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from './svgs/dynamic_price_icon.svg'

export const DynamicPriceIcon: React.VFC<SvgIconProps> = props => <SvgIcon component={Icon} {...props} />
